"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[738],{

/***/ 19146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gi": function() { return /* binding */ headerCloseButtonCSS; },
/* harmony export */   "Jk": function() { return /* binding */ headerCSS; },
/* harmony export */   "ZL": function() { return /* binding */ BottomModalButton; },
/* harmony export */   "hH": function() { return /* binding */ bottomModalCSS; },
/* harmony export */   "k2": function() { return /* binding */ headerWrapperCSS; }
/* harmony export */ });
/* unused harmony export contentCSS */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96964);
/* harmony import */ var _layout_Push__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23516);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38945);
/* harmony import */ var _Overlay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90814);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          max-height: 80%;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          height: ",
        ";\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          transform: translateY(0);\n          visibility: visible;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n          transform: translateY(100%);\n          visibility: hidden;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    margin: 0 auto;\n    position: absolute;\n    bottom: 0;\n    border-top-left-radius: ",
        "px;\n    border-top-right-radius: ",
        "px;\n    overflow: hidden;\n\n    ",
        "\n\n    transition: 0.4s cubic-bezier(0.25, 1, 0.5, 1);\n    will-change: transform;\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    justify-content: space-between;\n    padding: 0 ",
        "px;\n    height: ",
        "px;\n    border-bottom: 1px solid ",
        ";\n    background-color: ",
        ";\n\n    h4 {\n      text-align: center;\n      line-height: ",
        "px;\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: ",
        "px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  right: ",
        "px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    display: block;\n    width: 100%;\n    height: 100%;\n    max-height: inherit;\n    padding-bottom: ",
        "px;\n    overflow: auto;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n  z-index: 9;\n  ",
        "\n\n  @media (max-height: 340px) {\n    display: none;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}









var bottomModalCSS = function(isOpen, contentSize) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject4(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Radius.large */ .wU.large, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Radius.large */ .wU.large, contentSize === "fit" ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject()) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject1(), contentSize), isOpen ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject2()) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject3()));
};
var headerWrapperCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject5());
var headerCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, _styles_css__WEBPACK_IMPORTED_MODULE_3__/* .MODAL_HEADER_HEIGHT */ .PV, theme.border.light, theme.var.white, _styles_css__WEBPACK_IMPORTED_MODULE_3__/* .MODAL_HEADER_HEIGHT */ .PV);
};
var headerLeftButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject7(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.small */ .Ki.small);
var headerCloseButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject8(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.small */ .Ki.small);
var contentCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject9(), _styles_css__WEBPACK_IMPORTED_MODULE_3__/* .MODAL_HEADER_HEIGHT */ .PV, theme.var.white);
};
var BottomModal = function(_param) {
    var title = _param.title, contentSize = _param.contentSize, children = _param.children, leftButton = _param.leftButton, renderButton = _param.renderButton, className = _param.className, _close = _param.close, close = _close === void 0 ? true : _close, _header = _param.header, header = _header === void 0 ? true : _header, rest = _objectWithoutProperties(_param, [
        "title",
        "contentSize",
        "children",
        "leftButton",
        "renderButton",
        "className",
        "close",
        "header"
    ]);
    var open = rest.open, onClose = rest.onClose;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.u)();
    var contentContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (open) {
            if (contentContainerRef.current) {
                contentContainerRef.current.scrollTop = 0;
            }
        }
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_Overlay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, rest), {
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            css: bottomModalCSS(open, contentSize),
            children: [
                header && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("header", {
                    css: headerWrapperCSS,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                        css: headerCSS,
                        children: [
                            leftButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                                css: headerLeftButtonCSS,
                                children: leftButton(theme.var.black)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h4", {
                                children: title
                            }),
                            close && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                                css: headerCloseButtonCSS,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("button", {
                                    className: "icon-btn",
                                    type: "button",
                                    onClick: function() {
                                        return onClose();
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                        icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_2__/* .Close */ .x8,
                                        color: theme.var.black
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    css: contentCSS,
                    ref: contentContainerRef,
                    children: [
                        children,
                        renderButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_layout_Push__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            bottom: true,
                            size: _layout_Push__WEBPACK_IMPORTED_MODULE_4__/* .PushSize.bottomButton */ .z.bottomButton
                        })
                    ]
                }),
                renderButton === null || renderButton === void 0 ? void 0 : renderButton()
            ]
        })
    }));
};
/** Button */ var bottomModalBtnCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject10(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium, (0,_styles_css__WEBPACK_IMPORTED_MODULE_3__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.medium */ .Ki.medium));
var BottomModalButton = function(param) {
    var className = param.className, text = param.text, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        css: bottomModalBtnCSS,
        className: className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            text: text,
            disabled: disabled,
            onClick: onClick
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (BottomModal);


/***/ }),

/***/ 30738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54909);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var _components_common_BottomModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19146);
/* harmony import */ var _components_layout_Pad__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95833);
/* harmony import */ var _components_layout_Push__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23516);
/* harmony import */ var _api_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9622);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39854);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96261);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        "px 0;\n\n  .description {\n    padding-left: ",
        "px;\n\n    p {\n      font-size: ",
        "px;\n      margin-top: ",
        "px;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var settingItemCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.xsmall */ .TS.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xxsmall */ .Ki.xxsmall, theme.var.gray600);
};
var NotificationModal = function(_param) {
    var objectType = _param.objectType, objectId = _param.objectId, settingKey = _param.settingKey, notificationOption = _param.notificationOption, props = _objectWithoutProperties(_param, [
        "objectType",
        "objectId",
        "settingKey",
        "notificationOption"
    ]);
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var queryKey = _constants__WEBPACK_IMPORTED_MODULE_8__/* .QUERY_KEYS.SETTING.ONE */ .U7.SETTING.ONE(objectType, objectId);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(notificationOption), selectedOption = ref[0], setSelectedOption = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!notificationOption) {
            setSelectedOption(settingKey === "newReplyPushStatus" ? "default" : "partial_enable");
            return;
        }
        setSelectedOption(notificationOption);
    }, [
        notificationOption
    ]);
    var optimistic = (0,_utils_query__WEBPACK_IMPORTED_MODULE_9__/* .useOptimisticUpdate */ .p7)();
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useMutation)(function(value) {
        return (0,_api_user__WEBPACK_IMPORTED_MODULE_7__/* .postUserSettings */ .ZQ)(objectType, objectId, settingKey, value);
    }), updateNotificationSetting = ref1.mutate;
    var options = {
        followingUpdatePushStatus: [
            {
                label: t("전체 알림"),
                description: t("팔로잉하는 작가님의 모든 신규 작품/커뮤니티 알림을 받습니다."),
                value: "enable"
            },
            {
                label: t("맞춤 알림"),
                description: t("팔로잉하는 작가님의 작품/커뮤니티를 최근에 읽었거나, 오랜만에 올라온 작품/커뮤니티에 대해 알림을 받습니다."),
                value: "partial_enable"
            },
            {
                label: t("알림 끄기"),
                description: t("팔로잉하는 작가님의 신규 작품/커뮤니티 알림을 받지 않습니다."),
                value: "disable"
            }, 
        ],
        newEpisodePushStatus: [
            {
                label: t("전체 알림"),
                description: t("해당 작품의 모든 신규 회차 알림을 받습니다."),
                value: "enable"
            },
            {
                label: t("맞춤 알림"),
                description: t("해당 작품 신규 회차 이전화를 읽은 경우 알림을 받습니다."),
                value: "partial_enable"
            },
            {
                label: t("알림 끄기"),
                description: t("해당 작품 신규 회차 알림을 받지 않습니다."),
                value: "disable"
            }, 
        ],
        newReplyPushStatus: [],
        newGroundPushStatus: [
            {
                label: t("전체 알림"),
                description: t("해당 캐릭터의 모든 그라운드 글 알림을 받습니다."),
                value: "enable"
            },
            {
                label: t("맞춤 알림"),
                description: t("해당 캐릭터와 최근에 플레이 한 경우 알림을 받습니다."),
                value: "partial_enable"
            },
            {
                label: t("알림 끄기"),
                description: t("해당 캐릭터의 그라운드 글 알림을 받지 않습니다."),
                value: "disable"
            }, 
        ]
    };
    var handleChangeNotificationSetting = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setSelectedOption(value);
        updateNotificationSetting(value, {
            onSuccess: function(data) {
                optimistic.update(queryKey, data);
            }
        });
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_components_common_BottomModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
        title: t("알림 설정"),
        contentSize: "fit"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_layout_Pad__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("ul", {
                    children: options[settingKey].map(function(option) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("li", {
                            css: settingItemCSS,
                            onClick: function() {
                                return handleChangeNotificationSetting(option.value);
                            },
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Radio */ .Y8, {
                                    id: "notification-setting-".concat(option.value),
                                    name: "".concat(settingKey, "-setting"),
                                    value: option.value,
                                    checked: selectedOption === option.value,
                                    onChange: function() {
                                        return handleChangeNotificationSetting(option.value);
                                    }
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                                    className: "description",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h6", {
                                            children: option.label
                                        }),
                                        option.description && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
                                            children: option.description
                                        })
                                    ]
                                })
                            ]
                        }, "notification-".concat(option.value));
                    })
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_layout_Push__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                size: _components_layout_Push__WEBPACK_IMPORTED_MODULE_6__/* .PushSize.safe */ .z.safe,
                bottom: true
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (NotificationModal);


/***/ })

}]);